import React from "react";

const AdminChampionshipBracket = ({
  slotData,
  filteredTeams,
  thirdPlaceSlot,
  championshipSize,
  handleSizeChange,
  getM,
  handleTeamSelect,
  isTeamDisabled,
  stageIcon,
}) => {
  // Pomoćna funkcija za dohvat imena tima
  const getTeamName = (teamObj, teamId) => {
    if (teamObj?.name) return teamObj.name;
    if (teamId) {
      const found = filteredTeams.find((t) => t.id === teamId);
      if (found) return `${found.bracketLabel} - ${found.name}`;
    }
    return "???";
  };

  // Dinamički nazivi stupaca i ID-jevi ovisno o championshipSize
  const getColumnsConfig = (size) => {
    if (size === 16) {
      return {
        firstRoundTitle: "Šesnaestina završnice - 1/8",
        firstRoundSlots: slotData, // 1-8
        secondRoundIds: [9, 10, 11, 12],
        secondRoundTitle: "Osmina završnice - 1/4",
        semiFinalIds: [13, 14],
        finalId: 15,
      };
    } else if (size === 8) {
      return {
        firstRoundTitle: "Četvrtfinale",
        firstRoundSlots: slotData, // 1-4
        secondRoundIds: [5, 6],
        secondRoundTitle: "Polufinale",
        semiFinalIds: [],
        finalId: 7,
      };
    } else if (size === 4) {
      return {
        firstRoundTitle: "Polufinale",
        firstRoundSlots: slotData, // Slotovi 1-2 (Polufinale)
        secondRoundIds: [], // Nema srednje runde
        secondRoundTitle: "",
        semiFinalIds: [],
        finalId: 3, // Slot 3 je Finale
      };
    }
    return {
      firstRoundSlots: [],
      secondRoundIds: [],
      semiFinalIds: [],
      finalId: 1,
    };
  };

  const config = getColumnsConfig(championshipSize);

  return (
    <div
      className={`championship-wrapper admin-championship-wrapper bracket-size-${championshipSize}`}
    >
      <div
        className="championship-stage-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "15px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img src={stageIcon} alt="Stage" className="stage-img" />
          <h3>Uredi Završnicu</h3>
        </div>

        {/* Dropdown za odabir veličine završnice */}
        <div
          className="championship-size-selector"
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          <label
            style={{ fontWeight: "bold", fontSize: "14px", color: "#fff" }}
          >
            Broj ekipa:
          </label>
          <select
            value={championshipSize}
            onChange={(e) => handleSizeChange(e.target.value)}
            style={{
              padding: "6px 12px",
              borderRadius: "6px",
              background: "#222",
              color: "#fff",
              border: "1px solid #444",
              cursor: "pointer",
            }}
          >
            <option value={16}>16 Timova (1/8)</option>
            <option value={8}>8 Timova (Četvrtfinale)</option>
            <option value={4}>4 Tima (Polufinale)</option>
          </select>
        </div>
      </div>

      <div className="championship-scroll">
        {/* 1. STUPAC: POČETNA RUNDA (Dropdowni za odabir timova) */}
        <div className="championship-column stage-0">
          <h4 className="stage-title">{config.firstRoundTitle}</h4>
          <div className="matches-grid">
            {config.firstRoundSlots.map((slot) => {
              const m = getM(slot.id);
              return (
                <div key={slot.id} className="championship-match">
                  <div className="team admin-select-team">
                    <select
                      value={m.team_a_id || ""}
                      onChange={(e) =>
                        handleTeamSelect(slot.id, "t1", e.target.value)
                      }
                    >
                      <option value="">Odaberi</option>
                      {filteredTeams.map((t) => (
                        <option
                          key={t.id}
                          value={t.id}
                          disabled={
                            isTeamDisabled(t.id) && m.team_a_id !== t.id
                          }
                        >
                          {t.bracketLabel} - {t.name}
                        </option>
                      ))}
                    </select>
                    <span className="score">{m.scorea || 0}</span>
                  </div>
                  <div className="team admin-select-team">
                    <select
                      value={m.team_b_id || ""}
                      onChange={(e) =>
                        handleTeamSelect(slot.id, "t2", e.target.value)
                      }
                    >
                      <option value="">Odaberi</option>
                      {filteredTeams.map((t) => (
                        <option
                          key={t.id}
                          value={t.id}
                          disabled={
                            isTeamDisabled(t.id) && m.team_b_id !== t.id
                          }
                        >
                          {t.bracketLabel} - {t.name}
                        </option>
                      ))}
                    </select>
                    <span className="score">{m.scoreb || 0}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* 2. STUPAC: SREDNJA RUNDA (Prikazuje se samo za 16 i 8 timova) */}
        {config.secondRoundIds.length > 0 && (
          <div className="championship-column stage-1">
            <h4 className="stage-title">{config.secondRoundTitle}</h4>
            <div className="matches-grid">
              {config.secondRoundIds.map((id) => {
                const m = getM(id);
                return (
                  <div key={id} className="championship-match">
                    <div className="team">
                      <span>{getTeamName(m.team_a, m.team_a_id)}</span>
                      <span className="score">{m.scorea || 0}</span>
                    </div>
                    <div className="team">
                      <span>{getTeamName(m.team_b, m.team_b_id)}</span>
                      <span className="score">{m.scoreb || 0}</span>
                    </div>
                    <div className="vertical-line"></div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* 3. STUPAC: POLUFINALE (Prikazuje se samo za 16 timova) */}
        {config.semiFinalIds.length > 0 && (
          <div className="championship-column stage-2">
            <h4 className="stage-title">Polufinale - 1/2</h4>
            <div className="matches-grid">
              {config.semiFinalIds.map((id) => {
                const m = getM(id);
                return (
                  <div key={id} className="championship-match">
                    <div className="team">
                      <span>{getTeamName(m.team_a, m.team_a_id)}</span>
                      <span className="score">{m.scorea || 0}</span>
                    </div>
                    <div className="team">
                      <span>{getTeamName(m.team_b, m.team_b_id)}</span>
                      <span className="score">{m.scoreb || 0}</span>
                    </div>
                    <div className="vertical-line"></div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ZADNJI STUPAC: FINALE, POBJEDNIK I 3. MJESTO */}
        <div className="championship-column stage-3 final-stage">
          <h4 className="stage-title">Finale</h4>
          <div className="final-content-wrapper">
            {(() => {
              const m = getM(config.finalId);
              return (
                <div className="championship-match finale-box">
                  <div className="team">
                    <span>{getTeamName(m.team_a, m.team_a_id)}</span>
                    <span className="score">{m.scorea || 0}</span>
                  </div>
                  <div className="team">
                    <span>{getTeamName(m.team_b, m.team_b_id)}</span>
                    <span className="score">{m.scoreb || 0}</span>
                  </div>
                  <div className="vertical-line"></div>
                </div>
              );
            })()}

            <div className="trophy-container">
              <i className="fi fi-rs-trophy"></i>
              <h3>POBJEDNIK</h3>
              <div className="winner-box">
                {(() => {
                  const f = getM(config.finalId);
                  if (!f.is_completed) return "?";
                  return f.scorea > f.scoreb
                    ? getTeamName(f.team_a, f.team_a_id)
                    : getTeamName(f.team_b, f.team_b_id);
                })()}
              </div>
            </div>

            {/* 3. MJESTO */}
            <div className="third-place-container">
              <h4 className="stage-title">3. mjesto</h4>
              <div className="matches-grid">
                {(() => {
                  const m = getM(thirdPlaceSlot);
                  return (
                    <div className="championship-match">
                      <div className="team">
                        <span>{getTeamName(m.team_a, m.team_a_id)}</span>
                        <span className="score">{m.scorea || 0}</span>
                      </div>
                      <div className="team">
                        <span>{getTeamName(m.team_b, m.team_b_id)}</span>
                        <span className="score">{m.scoreb || 0}</span>
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminChampionshipBracket;
